module.exports = __webpack_public_path__ + "static/img/topBackGround.21a39958.png";